const withCompose = (...args) => {
  return (editor, plugin) =>
    args.reduce((acc, next) => next(acc, plugin), editor)
}

export { withCompose }
